
class CustomJS {
    constructor(name){
        this.selector = document.getElementById(name)
    }
    addClass(className){
        return this.selector.classList.add(className)
    }
    removeClass(className){
        return this.selector.classList.remove(className)
    }
    switchClass(className1, className2){
        this.selector.classList.remove(className1)
        return this.selector.classList.add(className2)
    }
    addClassToParent(count, className) {
        let parentObj = this.selector.parentElement
        let obj = CustomJS.accessParent(parentObj, count, className)
        return obj.classList.add(className)

    }
    removeClassToParent(count, className) {
        let parentObj = this.selector.parentElement
        let obj = CustomJS.accessParent(parentObj, count, className)
        return obj.classList.remove(className)

    }

    static accessParent(obj, count, className) {
        const newCount = count - 1
        if(newCount > 0) {
            const parentObj = obj.parentElement
           return CustomJS.accessParent(parentObj, newCount, className)
        }
        return obj
    }
}

export const _$ = (name) => {
    return new CustomJS(name)
}

// module.exports = {
//     _$
// }
